import Error from './validation-error.constants';
import Customer from './customer.form.constants';
import User from './user.form.constants';
import ManufacturerModel from './manufacturer-model.form.constants';
import Comment from './comment.form.constants';
import Company from './company.form.constants';
import UnitType from './unit-type.form.constants';
import Unit from './unit.form.constants';
import Fluid from './fluid.form.constants';

export default {
  Company,
  Unit,
  UnitType,
  Fluid,
  Comment,
  ManufacturerModel,
  Customer,
  User,
  Error
};
